"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionaryDefinition = void 0;
const needle_1 = __importDefault(require("needle"));
const util_1 = require("../../util");
/**
 * Get definitions of a word.
 * Data provided by Wordnik.
 * @category Spice
 * @see https://www.wordnik.com/
 * @param word The word to define
 * @param needleOptions The options for the HTTP request
 * @returns The dictionary definition result
 */
async function dictionaryDefinition(word, needleOptions) {
    if (!word)
        throw new Error('Word cannot be empty!');
    const response = await (0, needle_1.default)('get', `${util_1.SPICE_BASE}/dictionary/definition/${word}`, needleOptions);
    if (response.body.toString() === 'ddg_spice_dictionary_definition();\n')
        return [];
    const result = (0, util_1.parseSpiceBody)(response.body);
    return result;
}
exports.dictionaryDefinition = dictionaryDefinition;
